export default __webpack_public_path__ + "static/media/arrow_left.cdd99536.svg";